/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { getHotelVoucherDetailsApi } from '../../../api/hotelApi';
import { getUserDetails } from '../../../api/profileApi';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppColumnLabelValue from '../../../shared/components/app-column-label-value/AppColumnLabelValue';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  DATE_FORMAT,
  PAX_TYPE_DICT,
  STATUS_OPTIONS_DICT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  DATE_MONTH_YEAR_FORMAT,
} from '../../../shared/constants/Constants';
import {
  formatCurrency,
  formatDate,
  getNewDate,
  hideHeaderFooter,
  showHeaderFooter,
} from '../../../shared/helper-utils/appUtils';
import './BookingDetails.scss';
import {
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import NumberToWords from '../../../shared/components/NumberToWords';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { APP_LOGO_URL } from '../../../saas/AppStorageStaticNames';

function HotelInvoicePage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const [agent, setAgent] = useState(undefined);
  const passengerRef = useRef([]);
  const roomsRef = useRef([]);
  const [isSearchDone, setIsSearchDone] = useState(undefined);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const getHotelVoucherDetails = async () => {
    setLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res.ApiStatus.StatusCode === '200') {
      const { User } = res.ApiStatus.Result;
      setAgent(User);
    } else {
      setAlert({
        variant: 'error',
        title: 'User Info',
        description: res.ApiStatus?.Message,
      });
    }
    const response = await getHotelVoucherDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      let paxList = data.hotelpax;
      paxList = Array.isArray(paxList) ? paxList : [paxList];
      passengerRef.current = paxList;
      let roomsList = data.hotelrooms;
      roomsList = Array.isArray(roomsList) ? roomsList : [roomsList];
      roomsRef.current = roomsList;
      setBookingDetails(data);
      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Voucher Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel voucher details',
      });
      setHasTicket(false);
    }
    setIsSearchDone(true);

    setLoading(false);
  };

  useEffect(() => {
    getHotelVoucherDetails();
  }, []);

  return (
    <section className="flight-ticket-invoice-page pb-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <section className="print-links d-flex flex-column  hide-in-print">
        <a onClick={() => window.print()}>
          <img src="/images/others/print_sidebutton.png" alt="" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING}>
          <img src="/images/others/home_sidebutton.png" alt="" />
        </a>
      </section>
      {hasTicket !== undefined && hasTicket ? (
        <div
          style={{
            padding: '1rem 10px',
            width: '900px',
            marginInline: 'auto',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ border: '1px solid #000' }}>
            <div
              style={{
                padding: '10px',
                fontWeight: '600',
                borderBottom: '1px solid #000',
              }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="flex-1">
                <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt={appConfig?.companyName}
                  width="80px"
                />
              </div>
              <div className="flex-1 text-start">INVOICE</div>
            </div>
            <div
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                fontWeight: '300',
              }}
              className="d-flex flex-column"
            >
              {getValueFromAppConfig('INVADDRESS')
                .split('<br>')
                .map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
            </div>
            {Object.keys(agent).length > 0 && (
              <div
                className="py-1 fs-12 d-flex px-2"
                style={{ border: '1px solid #000' }}
              >
                <div className="d-flex flex-column flex-1 gap-1">
                  <span>
                    <b>To M/s:</b> {agent.Company}
                    <br />
                  </span>
                  <span>
                    <b>Address: </b>
                    {agent.Address1},{agent.Address2},{agent.City},{agent.State}
                    ,{agent.PinCode},
                    <br />
                  </span>
                  <span>
                    <b>Email: </b>
                    {agent.ContactEmail}
                    <br />
                  </span>
                  <span>
                    <b>Phone: </b>
                    {agent.ContactNumber}
                    <br />
                  </span>
                  <span>
                    <b>GSTN No: </b> {agent.Gst_number}
                  </span>
                </div>
                <div className="d-flex justify-content-end flex-1">
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>Invoice Date: </b>{' '}
                      {bookingDetails.tx_date?.split(' ')[0] &&
                        formatDate(
                          getNewDate(bookingDetails.tx_date?.split(' ')[0]),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Invoice No: </b> {bookingDetails.invoicenumber}
                    </span>
                    <span style={{ wordBreak: 'break-all' }}>
                      <b>Supplier Reference: </b>{' '}
                      {bookingDetails.supplier_reference}
                    </span>
                    <span>
                      <b>HSN/SAC: </b> 998551
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center p-1 fs-12 fw-500">
              Category Type : Hotel
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr>
                    <th colSpan={5} className="text-center">
                      Hotel Details
                    </th>
                  </tr>
                  <tr>
                    <th>Hotel Name/Address</th>
                    <th>City</th>
                    <th>Checkin Date</th>
                    <th>Checkout Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: '50%' }}>
                      {bookingDetails.hotel_name} <br />
                      {bookingDetails.hotel_address}
                    </td>
                    <td>{bookingDetails.hotel_citycode}</td>
                    <td>
                      {bookingDetails.checkin_time?.split(' ')[0] &&
                        formatDate(
                          getNewDate(
                            bookingDetails.checkin_time?.split(' ')[0],
                          ),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </td>
                    <td>
                      {bookingDetails.checkout_time?.split(' ')[0] &&
                        formatDate(
                          getNewDate(
                            bookingDetails.checkout_time?.split(' ')[0],
                          ),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100">
                <thead>
                  <tr>
                    <th colSpan="2" className="text-center">
                      Passenger Details
                    </th>
                  </tr>
                  <tr>
                    <th>Passenger Name</th>
                    <th>Passenger Contact</th>
                  </tr>
                </thead>
                <tbody>
                  {passengerRef.current.map((pax, index) => (
                    <tr key={index}>
                      <td style={{ textTransform: 'uppercase' }}>
                        {pax.salutation} {pax.firstname} {pax.lastname}
                      </td>
                      <td>{pax.phoneno}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="fs-12 d-flex justify-content-between gap-1 px-2 border-bottom pb-2">
              <div className="d-flex align-items-end">
                <p className="mb-0">
                  <b>Amount in Words : </b>
                  <span className="text-capitalize fw-300">
                    <NumberToWords
                      number={bookingDetails.farequote_amount.toFixed(2)}
                    />
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-end">
                <table>
                  <tbody>
                    <tr>
                      <td>[ + ] Basic</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.basefare.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Hotel Taxes</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.tax.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Service Charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.tax.toFixed(2)}
                      </td>
                    </tr>

                    <tr>
                      <td>[ + ] SGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.sgstonhc.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] CGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.cgstonhc.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] IGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.igstonhc.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ - ] commission</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.commission.toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-bottom">
                      <td>[ + ] TDS</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.tds.toFixed(2)}
                      </td>
                    </tr>
                    <tr className="fw-bold border-bottom">
                      <td>Total Billing Amount (Rs)</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.farequote_amount.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-2 fs-12 fw-600">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1 flex-column flex-1">
                  <span>
                    <b>Terms & Conditions: </b>
                  </span>
                  <ul>
                    <li>
                      This is computer generated invoice signature not required.
                    </li>
                    <li>
                      All Cases Disputes are subject to New Delhi jurisdiction.
                    </li>
                    <li>
                      Refunds Cancellations are subject to Supplier&apos;s
                      approval
                    </li>
                    <li>
                      Kindly check all details carefully to avoid unnecessary
                      complications.
                    </li>
                    <li>
                      CHEQUE : Must be drawn in favour of &quot;:{' '}
                      {appConfig?.companyName} &quot;
                    </li>
                    <li>
                      LATE PAYMENT : Interest @ 24% per annum will be charged on
                      all outstanding bills after the due date.
                    </li>
                    <li>
                      All transactions between the Company and the Agency are
                      subject to the Company&apos;s Privacy Policy and Terms and
                      Conditions
                    </li>
                    <li>
                      All invoices and credit notes are confidential and should
                      not be disclosed to third parties without prior written
                      consent from the Company.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-center mb-3">
                  <p>{getValueFromAppConfig('COMPANYNAME')}</p>
                  <span>Authorised Signature</span>
                </div>
              </div>
              <div
                style={{
                  marginTop: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                Bank Name : ICICI BANK | Account no :000705009962 | IFSC
                ICIC0006637 | Branch Connaught Place, New Delhi
              </div>
            </div>
          </div>
        </div>
      ) : (
        isSearchDone && <div>No receipt Found</div>
      )}
    </section>
  );
}

export default HotelInvoicePage;
